import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/pdf-templates']['GET'];
type Input = ThisApi['query'];

const getPdfTemplates = async ({ creatorId, page, perPage }: Input): Promise<ThisApi['response']> => {
  const data = await formsBackendClient.get('/pdf-templates', {
    params: { creatorId, page, perPage },
  });
  return data.data;
};

export default getPdfTemplates;
